import { dashboard } from './dashboard';
import { utilities } from './utilities';
import { other } from './other';

//-----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
    items: [utilities, dashboard, other]
};

export default menuItems;
